import { BaseKb3dModel } from '../decorators/kb3d-decorator';
import { eSideOrientation } from '../enums';
import { IPrimitiveMeshNode, IUvData } from '../kb3d-models';
import { Token } from '../token';
import { MeshNode } from './mesh-node';
import { SpaceNode } from './space-node';

@BaseKb3dModel({
    token: Token.PrimitiveMeshNode,
})
export abstract class PrimitiveMeshNode extends MeshNode implements IPrimitiveMeshNode {
    constructor() {
        super();
    }

    /** for baking in uv map data into the primitive mesh */
    public uvOverrides?: IUvData;
    public sideOrientation: eSideOrientation;

    copyPropertiesTo(target: SpaceNode) {
        super.copyPropertiesTo(target);
        if (target instanceof PrimitiveMeshNode) {
            target.uvOverrides = this.uvOverrides;
            target.sideOrientation = this.sideOrientation;
        }
    }
}
